import { Botao, Dialogo, Kbd } from '../ui';
import css from './LayoutPainel.module.css';

// "?" em qualquer tela: a lista curta do que o teclado faz. As letras soltas só abrem telas.
const ATALHOS: { teclas: string[]; faz: string }[] = [
  { teclas: ['N'], faz: 'Novo pedido' },
  { teclas: ['/'], faz: 'Buscar pedido, cliente, telefone ou rua' },
  { teclas: ['Esc'], faz: 'Volta para a lista; o rascunho fica guardado' },
  { teclas: ['Enter'], faz: 'No formulário, vai para o próximo campo' },
  { teclas: ['Shift Enter'], faz: 'No campo Pedido, quebra a linha' },
  { teclas: ['Ctrl Enter'], faz: 'Salva o pedido ou confirma o diálogo' },
  { teclas: ['↑', '↓'], faz: 'Na busca, escolhe o resultado' },
  { teclas: ['?'], faz: 'Esta lista' },
];

export function DialogoAtalhos({ aberto, aoFechar }: { aberto: boolean; aoFechar: () => void }) {
  return (
    <Dialogo aberto={aberto} aoFechar={aoFechar} rotulo="Atalhos do teclado">
      <h2 className={css.tituloAtalhos}>Atalhos do teclado</h2>
      <p className={css.dicaAtalhos}>As letras não valem com o cursor num campo.</p>
      <dl className={css.listaAtalhos}>
        {ATALHOS.map(({ teclas, faz }) => (
          <div key={faz} className={css.atalho}>
            <dt>
              {teclas.map((tecla) => (
                <Kbd key={tecla}>{tecla}</Kbd>
              ))}
            </dt>
            <dd>{faz}</dd>
          </div>
        ))}
      </dl>
      <div className={css.fecharAtalhos}>
        <Botao variante="secundario" pequeno onClick={aoFechar}>
          Fechar
        </Botao>
      </div>
    </Dialogo>
  );
}
